import Shifts from './Shifts';

export default Shifts;
